/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { ShopifyFieldMappingDtoModel, ShopifyFieldMappingDtoModelType } from "./ShopifyFieldMappingDtoModel"
import { ShopifyFieldMappingDtoModelSelector } from "./ShopifyFieldMappingDtoModel.base"
import { RootStoreType } from "./index"


/**
 * ShopifyConfigurationDtoBase
 * auto generated base class for the model ShopifyConfigurationDtoModel.
 */
export const ShopifyConfigurationDtoModelBase = ModelBase
  .named('ShopifyConfigurationDto')
  .props({
    __typename: types.optional(types.literal("ShopifyConfigurationDto"), "ShopifyConfigurationDto"),
    uuid: types.identifier,
    organizationUuid: types.union(types.undefined, types.string),
    fieldMappings: types.union(types.undefined, types.array(types.late((): any => ShopifyFieldMappingDtoModel))),
    customFields: types.union(types.undefined, types.array(types.string)),
    tagDeliveredOrders: types.union(types.undefined, types.boolean),
    updateFulfillmentOnDelivery: types.union(types.undefined, types.boolean),
    createdAt: types.union(types.undefined, types.string),
    updatedAt: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ShopifyConfigurationDtoModelSelector extends QueryBuilder {
  get uuid() { return this.__attr(`uuid`) }
  get organizationUuid() { return this.__attr(`organizationUuid`) }
  get customFields() { return this.__attr(`customFields`) }
  get tagDeliveredOrders() { return this.__attr(`tagDeliveredOrders`) }
  get updateFulfillmentOnDelivery() { return this.__attr(`updateFulfillmentOnDelivery`) }
  get createdAt() { return this.__attr(`createdAt`) }
  get updatedAt() { return this.__attr(`updatedAt`) }
  fieldMappings(builder: string | ShopifyFieldMappingDtoModelSelector | ((selector: ShopifyFieldMappingDtoModelSelector) => ShopifyFieldMappingDtoModelSelector) | undefined) { return this.__child(`fieldMappings`, ShopifyFieldMappingDtoModelSelector, builder) }
}
export function selectFromShopifyConfigurationDto() {
  return new ShopifyConfigurationDtoModelSelector()
}

export const shopifyConfigurationDtoModelPrimitives = selectFromShopifyConfigurationDto().uuid.organizationUuid.customFields.tagDeliveredOrders.updateFulfillmentOnDelivery.createdAt.updatedAt
